<template>
    <v-layout>
    <v-slide-x-reverse-transition>
      <v-flex class="fixed-search-field">
        <v-text-field
        box single-line
        class="white-box-field fixed-search-toggle-field"
        @keydown.enter="search()"
        v-model="searchTerm"
        label="Search..."
        color="secondary">
      </v-text-field>
      </v-flex>
    </v-slide-x-reverse-transition>
    </v-layout>

</template>

<script>

export default {
  name: "search-bar",
  data: () => ({ searchTerm: "", }),
  methods: {
    async search() {
      await this.$router.push({ name: "SearchResults", params: { search_term: this.searchTerm } })
      this.$store.commit("updateSearchTerm", this.searchTerm)
    }
  }
}
</script>

<style stylus>


.fixed-search-toggle-field.v-text-field--box.v-text-field--single-line input {
  margin-top:4px;
}

.fixed-search-toggle-field.v-text-field--box .v-label {
  top:9px;
}

.fixed-search-toggle-field .v-input__slot {
  border-radius:20px !important;
  min-height:38px !important;
  height:38px;
  padding:0 0 0 20px!important;
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.10), 0px 1px 18px 0px rgba(0,0,0,0.10);
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.10), 0px 1px 18px 0px rgba(0,0,0,0.10);
}

.fixed-search-toggle-field .v-input__slot:before,.fixed-search-toggle-field .v-input__slot:after {
  display:none !important;
}

.fixed-search-toggle-btn:hover:before, .fixed-search-toggle-btn:before {
  background:white !important;
}

.desktop-search .v-input__slot {
  min-height: 46px !important;
  background:rgba(255,255,255,0.7) !important;
  border-radius:23px !important;
  padding-left:20px !important;
}

.desktop-search .v-input__slot:before, .desktop-search .v-input__slot:after {
  display:none;
}

.desktop-search.v-text-field--box.v-text-field--single-line input {
  margin-top: 8px;
}

.desktop-search.v-text-field--box .v-label {
  top: 12px;
}

.desktop-search.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 11px;
}

  .desktop-search-field-btn {
    margin-top:-8px !important;
    margin-right:-8px;
  }

  .search-wrapper {
    max-width:380px;
    margin:7px auto 0 auto;
    padding:0 48px 0 0;
    position:relative;
  }
</style>
